module.exports = __webpack_public_path__ + "img/atletico-madrid-logo-icon.8351e409.png";